<template>
  <el-dialog title="验货" :visible.sync="visible" :before-close="inSpectionStateClose" width="1700px" :close-on-click-modal="false">
    <!-- table表格 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="title" label="商品名称" :key="1" />
      <el-table-column prop="brand" label="品牌" :key="2" />
      <el-table-column prop="skuValue" label="规格" :key="3" />
      <el-table-column prop="unit" label="单位" :key="4" width="80" />
      <el-table-column prop="goodsCount" label="采购数量" :key="5" align="center" />
      <el-table-column label="实收数量" :key="6" align="center">
        <template slot-scope="scope" v-if="scope.row.validationData">
          <el-input-number v-model="scope.row.validationData.paidCount" controls-position="right" :min="0" size="small" style="width: 100px"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="赠品数量" :key="7" align="center">
        <template slot-scope="scope" v-if="scope.row.validationData">
          <el-input-number v-model="scope.row.validationData.givingCount" controls-position="right" :min="0" size="small" style="width: 100px"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="总成本价" :key="8" align="center">
        <template slot-scope="scope" v-if="scope.row.validationData">
          <el-input-number v-model="scope.row.validationData.costPrice" controls-position="right" :min="-1" size="small" style="width: 100px"></el-input-number>
        
        </template>
      </el-table-column>
    </el-table>
    <!-- 异常状态 -->
    <div class="comH">异常状态</div>
    <div class="abnormal">
      <div class="abnormalView">
        <div class="abnormalViewName">漏发数量:</div>
        <el-input-number v-model="tableData[0].validationData.abnormalInfo.leakageCount" controls-position="right" :min="0" size="small" style="width: 100px"></el-input-number>
      </div>
      <div class="abnormalView" v-if="tableData[0].validationData">
        <div class="abnormalViewName">破损数量:</div>
        <el-input-number v-model="tableData[0].validationData.abnormalInfo.brokenCount" controls-position="right" :min="0" size="small" style="width: 100px"></el-input-number>
      </div>
      <div class="abnormalView" v-if="tableData[0].validationData">
        <div class="abnormalViewName">调换数量:</div>
        <el-input-number v-model="tableData[0].validationData.abnormalInfo.switchCount" controls-position="right" :min="0" size="small" style="width: 100px"></el-input-number>
      </div>
      <div class="abnormalView" v-if="tableData[0].validationData">
        <div class="abnormalViewName">无货数量:</div>
        <el-input-number v-model="tableData[0].validationData.abnormalInfo.noCount" controls-position="right" :min="0" size="small" style="width: 100px"></el-input-number>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmitClick">提 交</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateValidation } from "@/api/purchaseApiNew.js";
export default {
  props: {
    inSpectionState: {
      //显示状态
      default: false,
    },
    id: {
      //采购单id
      default: "",
    },
    inspectionData: {
      //商品数据
      default: {},
    },
  },
  data() {
    return {
      changeIndex: null,
      visible: true,
      tableData: [], //table数据
      step: 0,
      month: null,
      shengchanriqi: null,
      monthT: null,
      shengchanriqiT: null,
    };
  },
  created() {
    console.log(this.inspectionData);
    if (this.inspectionData.validationData != undefined) {
      for (let i = 0; i < this.inspectionData.validationData.length; i++) {
        this.inspectionData.validationData[i].overdue_time = new Date(
          this.inspectionData.validationData[i].overdue_time * 1000
        );
      }
      if (this.inspectionData.validationData.length > 1) {
        console.log(11111111);
      } else if (this.inspectionData.validationData.length == 1) {
        this.inspectionData.date =
          this.inspectionData.validationData[0].overdue_time.getTime();
        console.log(this.inspectionData.date);
      }
    }
    this.tableData = [this.inspectionData];
    console.log("table", this.tableData);
  },
  watch: {
    // 监视状态发生改变
    inSpectionState() {
      this.visible = this.inSpectionState;
    },
  },
  methods: {
    changeMonth() {
      let tableObj = this.tableData[0];
      this.month = tableObj.month; //保质期(月)
      this.getOverTime();
    },

    //提交
    handleSubmitClick() {
      var timestamp =
        Date.parse(new Date()) / 1000 + parseInt(60 * 60 * 24 * 30 * 9);
      console.log(this.tableData[0], "123");
      let tableObj = this.tableData[0];
      let actualNum = tableObj.validationData.paidCount; //实收数量
      let giveNum = tableObj.validationData.givingCount; //赠品数量
      let costPrice = tableObj.validationData.costPrice; //成本价

      //实收+异常  ===采购
      let yichangNum =
        this.loufaNum + this.posunNum + this.guoqiNum + this.diaohuanNum;

      // if(actualNum == 0 && giveNum == 0){
      // 	this.$message({
      // 		type:'warning',
      // 		message:'请填写实收数量或者赠品数量'
      // 	})
      // 	return
      // }

      // if (actualNum > 0 && costPrice == 0) {
      //   this.$message({
      //     type: "warning",
      //     message: "已填写实收数量，成本价必须填写",
      //   });
      //   return;
      // }

      if (
        yichangNum + actualNum > tableObj.goods_count &&
        tableObj.goods_count != 0
      ) {
        this.$message({
          type: "warning",
          message: "实收数量加异常数量不能大于采购数量",
        });
        return;
      }
      if (
        yichangNum + actualNum < tableObj.goods_count &&
        tableObj.goods_count != 0
      ) {
        this.$message({
          type: "warning",
          message: "实收数量加异常数量不能小于采购数量",
        });
        return;
      }
      let parmars = {
        procureGoodsId: tableObj.id, //采购商品id
        validationData: {
          paidCount: actualNum, //实收数量
          givingCount: giveNum, //赠送数量
          abnormalInfo: {
            leakageCount: tableObj.validationData.abnormalInfo.leakageCount, //漏发数量
            brokenCount: tableObj.validationData.abnormalInfo.brokenCount, //破损数量
            switchCount: tableObj.validationData.abnormalInfo.switchCount, //调换数量
            noCount: tableObj.validationData.abnormalInfo.noCount, //无货数量
          },
          costPrice: costPrice,
          remarks: tableObj.validationData.remarks,
        },
      };
      updateValidation(parmars).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.$message({
            type: "success",
            message: "验货",
          });
          this.$emit("refresh", false);
          // this.visible = false;
        }
      });
    },

    //关闭弹框
    inSpectionStateClose(done) {
      done();
      this.$emit("closeOn", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.comH {
  font-size: 16px;
  color: #000;
  margin: 20px 0;
}

.abnormal {
  display: flex;
  align-items: center;

  .abnormalView {
    display: flex;
    align-items: center;
    margin-right: 60px;

    .abnormalViewName {
      font-size: 14px;
      color: #000;
      margin-right: 10px;
    }
  }
}

.dateView {
  display: flex;
  margin: 20px 0;
  align-items: center;
  font-size: 16px;

  .dateTitle {
    color: #000;
    margin-right: 20px;
  }

  .dateItem {
    display: flex;
    align-items: center;
    margin-right: 20px;

    .dateItemName {
      margin-right: 10px;
    }
  }
}
</style>
